export enum MeshType {
  GIS_GROUND,
  GIS_BUILDING,

  DECAL_GRASS,
  DECAL_CAR_ROAD,
  DECAL_WALK_ROAD,
  DECAL_EDGE,
  DECAL_PLAYGROUND,
  DECAL_GYM,
  DECAL_RECYCLE,
  DECAL_WATER,

  DONG_PROP,
  DONG_FRAME,
  DONG_ROOMTYPE_WALL,
  DONG_ROOF_TOP,
  DONG_EFFECT,
  DONG_ITEM_HO,

  FACILITY_TREE_NORMAL,
  FACILITY_TREE_BUSH,
  FACILITY_TREE_FLOWER,
  FACILITY_GYM,
  FACILITY_PARKING,
  FACILITY_PARKING_ENTERANCE,
  FACILITY_BUILDING,
}
